// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2GGxc","checkboxCol":"Table_checkboxCol__1JzB7","emailCol":"Table_emailCol__21RaH","actionCol":"Table_actionCol__3dNMX"};